export default __webpack_public_path__ + "static/media/87-min.0db3cda9.jpg";